
export const SuccessModel = (props) =>{

    return   <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <div className="modal__header--logo">
              <svg width="93" height="93" viewBox="0 0 93 93" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M85.0301 42.7285V46.2764C85.0253 54.5923 82.3325 62.6839 77.3533 69.3445C72.3741 76.005 65.3752 80.8775 57.4006 83.2354C49.4259 85.5933 40.9026 85.3101 33.102 82.4282C25.3014 79.5463 18.6414 74.22 14.1152 67.2437C9.58897 60.2674 7.43914 52.0149 7.9863 43.7169C8.53347 35.419 11.7483 27.5202 17.1514 21.1987C22.5544 14.8771 29.8562 10.4715 37.9677 8.63878C46.0792 6.80609 54.5658 7.64457 62.1618 11.0292M85.0301 15.4254L46.4664 54.0277L34.8973 42.4586" stroke="#8b58f1" stroke-width="2.89228" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>               
            </div>
          </div>
          <div className="modal__body">
            <h4 className="promptMessage">
              {props.message}
            </h4>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
}